import { render, staticRenderFns } from "./SChipDark.vue?vue&type=template&id=0681e619&functional=true&"
import script from "./SChipDark.vue?vue&type=script&lang=js&"
export * from "./SChipDark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports